<template>
  <cube-scroll class="page-index-scroll">
    <router-view/>
  </cube-scroll>
</template>

<script>
export default {
  name: 'PageIndex'
}
</script>

<style lang="scss">
  .page-index-scroll {
    &.cube-scroll-wrapper {
      height: 100%;
      &>.cube-scroll-content {
        height: 100%;
        &>.cube-scroll-list-wrapper {
          height: 100%;
        }
      }
    }
  }
</style>
